import React, { useEffect, useState } from "react";
import "./App.css";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Header from "./components/partials/Header";
import SideMenu from "./components/partials/SideMenu";
import { createToken } from "./utils/CreateApi";
import { getData, removeData } from "./utils/CookieUtiles";
import NetworkStatusMonitor from "./components/common/networkStatus/NetworkStatusMonitor";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import SnackbarComponent from "./components/common/snakebar/SnakebarComponnet";
import DynamicTitleAndIcon from "./components/pages/dashboard/DynamicTitle";
import Login from "./components/pages/login/Login";
import Dashborad from "./components/pages/dashboard/Dashboard";
import Booking from "./components/pages/booking/Booking";
import { AuthProvider } from "./contexts/AuthContext";
import PartnerManagement from "./components/pages/partner/PartnerManagement";
import KYCManagement from "./components/pages/kyc/KYCManagement";
import { ContextApiProvider } from "./contexts/UseEscapKeyContext";
import PincodeManagement from "./components/pages/dashboard/setting/PincodeManagement";
import GangLederManagement from "./components/gangLeader/GangLederManagement";
import Interest from "./components/pages/interest/Interest";
import Setting from "./components/pages/setting/Setting";
import FOManagement from "./components/pages/FOManagement/FOManagement";

function App() {
    const [loggedIn, setLoggedIn] = useState(() => {
    const token = getData("RefreshToken");
    return !!token;
  });
  return (
    <SnackbarProvider>
      <SnackbarComponent />
        
      <NetworkStatusMonitor />       
      <DynamicTitleAndIcon /> 
      <AuthProvider  loggedIn={loggedIn}>
          <ContextApiProvider>         
      <MainAppContent loggedIn={loggedIn} setLoggedIn={setLoggedIn} />   
        </ContextApiProvider>    
   </AuthProvider>
    </SnackbarProvider>
  );
}
function MainAppContent({loggedIn,setLoggedIn}) {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const navigate = useNavigate();

  const [authToken, setAuthToken] = useState(getData("AccessToken"));
  const handleLogin = () => {
    setLoggedIn(true);
    navigate("/");
  };
  useEffect(() => {
    const accessToken = getData("AccessToken");
    const refreshToken = getData("RefreshToken");
      
    if (accessToken) {
      setAuthToken(accessToken);
    } else if (!accessToken && refreshToken) {
      createToken(navigate, setLoggedIn);
      const token = getData("AccessToken");
      setAuthToken(token);
    } else if (!refreshToken) {
      handleLogout(); 
    }
  }, [authToken, getData("AccessToken")]);

  const handleLogout = () => {
    navigate("/login");
    setLoggedIn(false);
    removeData("AccessToken");
    removeData("RefreshToken");
  };

  const handleResize = () => {
    if (window.innerWidth >= 1280) {
      setDrawerOpen(true);
    } else {
      setDrawerOpen(false);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <NetworkStatusMonitor />
      <DynamicTitleAndIcon />
      {!loggedIn ? (
        <Login setLoggedIn={handleLogin} to="/login" />
      ) : (
        <div className="app">
          <Header
            setDrawerOpen={setDrawerOpen}
            drawerOpen={drawerOpen}
            setLoggedIn={handleLogout}
          />
          <div className="main">
            {drawerOpen && (
              <SideMenu open={drawerOpen} setOpen={setDrawerOpen} />
            )}
            <div
              className={`content ${
                drawerOpen ? "content-open" : "content-closed"
              }`}
            >
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashborad />} />     
                <Route path="/booking" element={<Booking />} /> 
                <Route path="/partner" element={<PartnerManagement />} /> 
                <Route path="/kyc" element={<KYCManagement />} />
                <Route path="/pincode-management" element={<PincodeManagement />} />
                <Route path="/gangleader-management" element={<GangLederManagement />} /> 
                <Route path="/field-officer-management" element={<FOManagement />} />           
                <Route path="/interest" element={<Interest />} />
                <Route path="/settings" element={<Setting />} />               
              </Routes>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
